import { post, get } from '../services/api';

export const enregistrerCommande = async (formData, panier) => {
  const produitsSimplifies = panier.map((p) => ({
    id: typeof p.id === 'string' && p.id.includes('-')
      ? parseInt(p.id.split('-')[0], 10)
      : parseInt(p.id, 10),
    quantite: Number(p.quantite ?? p.quantity ?? 0),
  }));

  const payload = { ...formData, panier: produitsSimplifies };
  console.log('[FRONT] POST /api/commande payload =', payload);

  try {
    const res = await post('/commande', payload, {
      headers: { 'Content-Type': 'application/json' },
    });
    console.log('[FRONT] /api/commande status =', res.status, 'data =', res.data);
    return res.data;
  } catch (error) {
    console.error(
      '[FRONT] /api/commande ERROR status =',
      error.response?.status,
      'data =',
      error.response?.data
    );
    throw error;
  }
};

// Récupérer les commandes pour un vendeur
export const fetchCommandesClientPourVendeur = async (vendeurId) => {
  try {
    const res = await get(`/commandes/vendeur/${vendeurId}`);
    return res.data; // axios renvoie déjà `data`
  } catch (error) {
    console.error('[FRONT] fetchCommandesClientPourVendeur ERROR', error);
    throw error;
  }
};
